<template>
  <section>
    <vue-headful :title="$t('TITLE_TYPE', { type: $tc('SERVICE', 2) }) | formatTitle"></vue-headful>
    <service-list :serviceType="serviceType"></service-list>

    <router-view class="services__route"></router-view>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import ServiceList from './ServiceList'
export default {
  name: 'services',
  components: { ServiceList },

  props: ['serviceType']
}
</script>
